import React, { useContext } from 'react';
import { MdClose } from 'react-icons/md';
import { AuthContext } from '../context/AuthContext';
import './FirstTimeOnboardingBanner.css';

/**
 * One-time welcome banner shown only on a freshly onboarded user's first
 * session (driven by user.showFirstTimeNotice from the login response). The
 * user can dismiss it at any time; dismissing persists server-side so it never
 * reappears on subsequent logins. Logging out clears the flag too.
 */
export default function FirstTimeOnboardingBanner() {
  const { user, dismissOnboardingNotice } = useContext(AuthContext);

  if (!user?.showFirstTimeNotice) return null;

  return (
    <div className="ftob" role="status" aria-live="polite">
      <p className="ftob-text">
        <strong>Welcome to CET QPG!</strong> You have successfully logged in using your
        initial onboarding credentials. A confirmation link has been sent to your registered
        email address if you wish to reset your password. You can dismiss this notice and update
        your password at any time via your Profile Settings.
      </p>
      <button
        type="button"
        className="ftob-dismiss"
        onClick={dismissOnboardingNotice}
        aria-label="Dismiss welcome notice"
      >
        <MdClose aria-hidden="true" />
        Dismiss
      </button>
    </div>
  );
}
